import React from 'react';
import { BoKNavigation } from 'lib/templates/Feature.BOKF.model';
import { useRouter } from 'next/router';

import SVG from 'helpers/SVG/SVG';

type EnhancedSearchLandingProps = BoKNavigation.SiteSearch;

const EnhancedSearchLanding = (props: EnhancedSearchLandingProps) => {
  const router = useRouter();
  const { SearchFormTarget } = props.fields || {};

  const handleSearchButtonClick = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    router.push(SearchFormTarget?.value?.href || '#');
  };

  return (
    <section className="container bokf-enhanced-search-landing">
      <div className="relative block w-full max-w-[582px] mx-auto">
        <input
          type="text"
          placeholder={props.fields?.SearchBarPlaceholderText?.value || 'Search...'}
          className="peer border border-light-stroke-primary rounded-full w-full p-2 pl-4 pr-[94px] bg-light-background-neutral-variant shadow-small focus:outline-none focus:ring-0 focus:outline-offset-[-1px] focus:outline-light-stroke-primary-variant placeholder:p3 placeholder:text-light-fill-primary-variant p3-medium"
          aria-label="Search"
        ></input>
        <div className="absolute top-0 right-0 bottom-0">
          <button
            className="flex items-center justify-center 
              w-[46px] h-full 
              rounded-r-full bg-light-background-gradient 
              hover:bg-light-background-gradient-hover
              focus:bg-light-background-gradient-focus  peer-focus:text-light-fill-secondary"
            type="button"
            aria-label="Search Button"
            onClick={handleSearchButtonClick}
          >
            <span className="sr-only">Search</span>
            <SVG
              svg="icon-search2"
              hidden={false}
              className="[&_svg]:h-5 [&_svg]:w-5 [&_path]:stroke-light-fill-inverse"
            ></SVG>
          </button>
        </div>
      </div>
    </section>
  );
};
export default EnhancedSearchLanding;
